import { useContext } from "react";
import { UserContext } from "../../../sesh_router";

export function useUserContext() {
	return useContext(UserContext);
}
